import Nullstack from 'nullstack';
export default function IconArtboardOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-artboard-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 8h3a1 1 0 0 1 1 1v3"
  }), "   ", Nullstack.element("path", {
    d: "M15.716 15.698a0.997 .997 0 0 1 -.716 .302h-6a1 1 0 0 1 -1 -1v-6c0 -.273 .11 -.52 .287 -.7"
  }), "   ", Nullstack.element("path", {
    d: "M3 8h1"
  }), "   ", Nullstack.element("path", {
    d: "M3 16h1"
  }), "   ", Nullstack.element("path", {
    d: "M8 3v1"
  }), "   ", Nullstack.element("path", {
    d: "M16 3v1"
  }), "   ", Nullstack.element("path", {
    d: "M20 8h1"
  }), "   ", Nullstack.element("path", {
    d: "M20 16h1"
  }), "   ", Nullstack.element("path", {
    d: "M8 20v1"
  }), "   ", Nullstack.element("path", {
    d: "M16 20v1"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}